import * as C from '../constants';
import { Lng } from '../enums';

const INITIAL_STATE = Object.freeze({
  lng: Lng.LV,
  errorData: [],
  appData: null,
  themesData: null,
  themeData: null,
  surveyData: null,
  successData: null,
  footerData: null,
  answersPreviewData: null,
  answersData: null,
  allAnswersData: null,
  searchData: null,
  translationsData: null,
  draftsData: null,
  authData: null,
  isLoginDialogOpen: false,
});

// eslint-disable-next-line
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case C.SET_LANGUAGE: {
      return {
        ...state,
        lng: action.payload,
      };
    }
    case C.STORE_ERROR: {
      const existingErrors = state.errorData;
      const latestError = [action.payload];
      const errorData = [...existingErrors, ...latestError];

      return {
        ...state,
        errorData,
      };
    }
    case C.CLOSE_ERROR: {
      const existingErrors = state.errorData;
      // eslint-disable-next-line
      const removedError = existingErrors.shift();
      const errorData = [...existingErrors];

      return {
        ...state,
        errorData,
      };
    }
    case C.APP_DATA: {
      return {
        ...state,
        appData: action.payload,
      };
    }
    case C.THEMES_DATA: {
      return {
        ...state,
        themesData: action.payload,
      };
    }
    case C.THEME_DATA: {
      return {
        ...state,
        themeData: action.payload,
      };
    }
    case C.SURVEY_DATA: {
      return {
        ...state,
        surveyData: action.payload,
      };
    }
    case C.FOOTER_DATA: {
      return {
        ...state,
        footerData: action.payload,
      };
    }
    case C.SHOW_SUCCESS: {
      return {
        ...state,
        successData: action.payload,
      };
    }
    case C.SHOW_LOGIN: {
      return {
        ...state,
        isLoginDialogOpen: true,
      };
    }
    case C.HIDE_LOGIN: {
      return {
        ...state,
        isLoginDialogOpen: false,
      };
    }
    case C.ANSWERS_PREVIEW_DATA: {
      return {
        ...state,
        answersPreviewData: action.payload,
      };
    }
    case C.ANSWERS_DATA: {
      return {
        ...state,
        answersData: action.payload,
      };
    }
    case C.ALL_ANSWERS_DATA: {
      return {
        ...state,
        allAnswersData: action.payload,
      };
    }
    case C.SEARCH_DATA: {
      return {
        ...state,
        searchData: action.payload,
      };
    }
    case C.DRAFTS_DATA: {
      return {
        ...state,
        draftsData: action.payload,
      };
    }
    case C.AUTH_DATA: {
      return {
        ...state,
        authData: action.payload,
      };
    }
    case C.TRANSLATIONS_DATA: {
      return {
        ...state,
        translationsData: action.payload,
      };
    }
    default:
      return state;
  }
};
